module.exports = __webpack_public_path__ + "img/button-icon-edit.cda77bfa.svg";